var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main",class:_vm.$style.main},[_c('vue-headful',{attrs:{"title":_vm.getPageTitle(_vm.pageTitle)}}),_c('div',{class:_vm.$style.titleContainer},[_vm._v(_vm._s(_vm.projectTitle)+" ")]),(_vm.isBpis || _vm.isSr || _vm.isSrp)?_c('PdfViewer'):_c('DocumentEditor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }